<script>
import orderForm from '../../../orders/accepts/collection/_Form.vue'

export default {
  name: "EditEntryPatternModal",
  components: {
    orderForm
  },
  props: {
    enable: {
      type: Boolean,
      default: false,
    },
    emissionId: {
      type: Number,
      default: null,
    },
    targetId: {
      type: Number,
      default: null,
    },
    callerType: {
      type: String,
      default: 'collection',
    },
  },
  data () {
    return {
      key: 0,
      buttonLocked: false,
      hidePastManifest: false,
    }
  },
  watch: {
    enable (newValue) {
      if (newValue) {
        this.key += 1;
        this.$nextTick().then(function() {
          document.documentElement.classList.add('overflow-y-hidden')
        })
      } else{
        this.$nextTick().then(function() {
          document.documentElement.classList.remove('overflow-y-hidden')
        })
      }
    }
  },
  created() {
  },
  methods: {
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('closeCallback');
    },
    /**
     * 受注登録ボタン クリックイベント
     */
    registerButtonClickEvent () {
      this.$refs.orderForm.registerEntryPattern();
    },
    /**
     * 受注登録 コールバック
     */
    registerCallback () {
      this.$emit('registerCallback');
    },
    /**
     * ボタン制御
     * @param value
     */
    loadingCallback (value) {
      this.buttonLocked = value
    }
  },
}
</script>

<template>
  <div>
    <v-dialog
      :value="enable"
      fullscreen
      persistent
      scrollable
      transition="dialog-bottom-transition"
      @keydown.esc="closeButtonClickEvent"
      @close="closeButtonClickEvent"
    >
      <v-card flat>
        <v-toolbar
          flat
          class="primary white--text"
          style="flex: initial"
        >
          <v-toolbar-title>
            登録パターン編集
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn
              icon
              dark
              @click="closeButtonClickEvent"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text>
          <v-container>
            <order-form
              ref="orderForm"
              :key="key"
              :callable-type="callerType"
              :entry-pattern-emission-id="emissionId"
              :entry-pattern-id="targetId"
              :hide-past-manifest="hidePastManifest"
              load-by="emission"
              @registerCallback="registerCallback"
              @loadingCallback="loadingCallback"
            />
          </v-container>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="closeButtonClickEvent"
          >
            閉じる
          </v-btn>
          <v-btn
            :disabled="buttonLocked"
            class="mr-15"
            color="primary"
            @click="registerButtonClickEvent"
          >
            更新
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped lang="scss">

</style>

<style lang="scss">
// フルスクリーンモーダル表示中の背景スクロール防止（Windows対応）
.v-dialog--fullscreen {
  overflow-y: auto !important;
}
</style>
